import * as React from "react";

const FileUploadContext = React.createContext({
    isUploading: false,
    setIsUploading: () => {},
});

export function FileUploadProvider({children}) {
    const [isUploading, setIsUploading] = React.useState(false);

    const value = React.useMemo(() => ({isUploading, setIsUploading}), [isUploading]);

    return (
        <FileUploadContext.Provider value={value}>
            {children}
        </FileUploadContext.Provider>
    );
}

export function useFileUpload() {
    return React.useContext(FileUploadContext);
}
